import React, { useEffect, useState } from 'react';
import { Button, MasterDetailForm, FormSelect, InlineEditColumnProps, ColumnType, FormDatePicker, FormTextArea, FormSubmitButton, Row, Col, notification, Table, ColumnProps } from '@digital/ui';
import { Tooltip, Modal } from 'antd';
import { UploadFile, UploadSimpleComponent, Visibility } from '@app/components';
import ModalComentariosParecerTecnico from './ComentariosParecerTecnico/ModalComentariosParecerTecnico';
import { excluirParecerTecnicoRevisao, getParecerTecnicoRevisao, ISasParecerTecnicoRevisao, ISasPropostaOrdemCompraDocs, updateDataRealConclusaoParecerTecnico, updateParecerTecnicoAprovacao, updateParecerTecnicoRevisao } from '@app/api/sas/sasProposta';
import { downloadArquivo, incluirDocumentoParecerTecnico, substituirSasArquivoDocumentoOrdemCompra } from '@app/api/sas/sasDocumentoOrdemCompra';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { ordemCompraIdState, stepState, fluxoProcessoState, modalAcoesIdState, reloadVendorListState, editandoState, vendorListDocsState } from '../atoms';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';
import locale from 'antd/es/date-picker/locale/pt_BR';
import './custom.css';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import moment from 'moment';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import ModalExibicaoArquivos from '../WidgetDocumentacao/ModalExibicaoArquivos';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';


interface Props {
    sasProposta: any;
}

const ModalParecerTecnico = (props: Props) => {
    const { sasProposta } = props;

    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const setModalAcoesId = useSetRecoilState(modalAcoesIdState);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const step = useRecoilValue(stepState);
    const [editando, setEditando] = useRecoilState(editandoState);

    const vendorListDocs = useRecoilValue(vendorListDocsState);

    const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);

    const [exibirModal, setExibirModal] = useState(false);
    const [dadosTabela, setDadosTabela] = useState<any[]>([]);
    const [updateFlag, setUpdateFlag] = useState(false);
    const [dataRealConclusao, setDataRealConclusao] = useState();
    const [disabled, setDisabled] = useState(true);
    const [formValues, setFormValues] = useState({
        comentarioResultadoParecerTecnico: '',
        anexoAprovacaoAreaRequisitante: undefined,
        anexoAprovacaoGerenteGeral: undefined,
    });

    useEffect(() => {
        if (exibirModal) {
            getParecerTecnicoRevisao(sasProposta.id).then(data => {
                if (data) {
                    setDadosTabela(data);
                }
            });
        }
        return () => { };
    }, [exibirModal, updateFlag]);

    useEffect(() => {
        if (editando.sasPropostaId === sasProposta.id
            || (isObjEmpty(sasProposta.statusResultadoParecerTecnico) || sasProposta.statusResultadoParecerTecnico == "Em Avaliação" || sasProposta.statusResultadoParecerTecnico == "Em Reavaliação" || sasProposta.statusResultadoParecerTecnico == "Aguardando Comprador" || sasProposta.statusResultadoParecerTecnico == "Aguardando Fornecedor")) {
            setDisabled(false);
        } else if (['Aprovado', 'Reprovado'].includes(sasProposta.statusResultadoParecerTecnico)) {
            setDisabled(true);
        }

        if (formValues.comentarioResultadoParecerTecnico === '') {
            setFormValues({ ...formValues, comentarioResultadoParecerTecnico: sasProposta.comentarioResultadoParecerTecnico });
        }

        if (sasProposta.dataRealConclusaoParecerTecnico) {
            setDataRealConclusao(sasProposta.dataRealConclusaoParecerTecnico);
        }

        return () => { };
    }, [sasProposta, editando]);

    const update = () => {
        setUpdateFlag(!updateFlag);
    };

    const onReloadVendorList = () => {
        setReloadVendorList(!reloadVendorList);
    };

    const handleCancel = () => {
        setExibirModal(false);
        setModalAcoesId('');
    };

    const validarLinhas = () => {
        if (dadosTabela.findIndex(c => isObjEmpty(c.dataRealizadaRetornoParecerRevisaoProponente)) >= 0) {
            notification.error("É necessário preencher a coluna 'DATA REALIZADA ÁREA REQUISITANTE' de todas as linhas");
            return false;
        }

        return true;
    };

    const handleUpdate = (values: any) => {
        return updateParecerTecnicoRevisao(values).then(data => {
            update();
        });
    };

    const handleAdd = () => {
        if (validarLinhas()) {
            return updateParecerTecnicoRevisao({ id: '', sasPropostaId: sasProposta.id }).then(data => {
                update();
            });
        }
    };

    const handleExcluir = (id: string) => {
        return excluirParecerTecnicoRevisao(id).then(data => {
            update();
        });
    };

    const handleEditDataResultadoParecerTecnico = (data) => {
        setDataRealConclusao(data);
        updateDataRealConclusaoParecerTecnico({ sasPropostaId: sasProposta.id, data });
    };

    const submitAprovacao = (values: any) => {
        if (!validarLinhas()) return;
        const form = new FormData();
        form.append('sasPropostaId', sasProposta.id);
        form.append('aprovacao', values.aprovacao);
        form.append('comentarioResultadoParecerTecnico', formValues.comentarioResultadoParecerTecnico);
        form.append('anexoAprovacaoAreaRequisitante', formValues.anexoAprovacaoAreaRequisitante);
        form.append('anexoAprovacaoGerenteGeral', formValues.anexoAprovacaoGerenteGeral);

        Modal.confirm({
            title: '',
            content: `Confirma a ${values.aprovacao ? 'APROVAÇÃO' : 'REPROVAÇÃO'} ?`,
            cancelText: 'Cancelar',
            onCancel: () => { },
            okText: 'Confirmar',
            onOk: () => {
                if (editando.sasPropostaId == sasProposta.id) {
                    Modal.confirm({
                        title: <>{editando.justificativa}</>,
                        content: <ModalConfirmContentJustificativa
                            texto='É necessário informar a justificativa para a alteração.'
                            setJustificativa={e => {
                                form.set('justificativaEdicao', e);
                            }}
                        />,
                        okText: 'Confirmar',
                        cancelText: 'Cancelar',
                        onOk: async (e) => {
                            form.append('editando', 'true');
                            return new Promise((resolve, reject) => {
                                updateParecerTecnicoAprovacao(form).then(data => {
                                    if (data && data.valid) {
                                        onReloadVendorList();;
                                        handleCancel();
                                        setModalAcoesId('');
                                        return resolve(true);
                                    } else {
                                        if (data.notifications && data.notifications.length > 0) {
                                            const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                                return c.property == 'justificativaEdicao';
                                            });
                                            if (erroJustificativaEdicao >= 0) {
                                                return reject(false);
                                            }
                                        }
                                    }
                                });
                            });
                        },
                        onCancel: () => { setModalAcoesId(''); }
                    });
                } else {
                    updateParecerTecnicoAprovacao(form).then(data => {
                        if (data && data.valid) {
                            onReloadVendorList();;
                            handleCancel();
                            setModalAcoesId('');
                        }
                    });
                }
            },
        });
    };

    const columnsTable = () => {
        let columns: ColumnProps<ISasParecerTecnicoRevisao>[] = [];


        columns.push({
            title: 'Data Envio Proponente',
            dataIndex: 'dataEnvioSolicitacaoRevisaoProponente',
            key: 'dataEnvioSolicitacaoRevisaoProponente',
            width: '15%',
            render: (text, record, index) => (
                disabled || record.isShowActions == false
                    ? record.dataEnvioSolicitacaoRevisaoProponente && moment(record.dataEnvioSolicitacaoRevisaoProponente).format(dateFormat)
                    : <FormDatePicker
                        name='dataEnvioSolicitacaoRevisaoProponente'
                        value={record.dataEnvioSolicitacaoRevisaoProponente ? moment(record.dataEnvioSolicitacaoRevisaoProponente) : undefined}
                        format='DD/MM/YYYY'
                        disabled={disabled || record.isShowActions == false}
                        locale={locale}
                        allowClear
                        onChange={e => {
                            record.dataEnvioSolicitacaoRevisaoProponente = e !== null ? e.toDate() : undefined;
                            handleUpdate({ ...record, dataEnvioSolicitacaoRevisaoProponente: e !== null ? e.toDate() : undefined });
                        }}
                    />
            )
        });

        columns.push({
            title: 'Data Retorno Proponente',
            dataIndex: 'dataRetornoRevisaoProponente',
            key: 'dataRetornoRevisaoProponente',
            type: ColumnType.Date,
            width: '15%',
            render: (text, record, index) => (
                disabled || record.isShowActions == false
                    ? record.dataRetornoRevisaoProponente && moment(record.dataRetornoRevisaoProponente).format(dateFormat)
                    : <FormDatePicker
                        name='dataRetornoRevisaoProponente'
                        value={record.dataRetornoRevisaoProponente ? moment(record.dataRetornoRevisaoProponente) : undefined}
                        format='DD/MM/YYYY'
                        disabled={disabled || record.isShowActions == false}
                        locale={locale}
                        allowClear
                        onChange={e => {
                            record.dataRetornoRevisaoProponente = e !== null ? e.toDate() : undefined;
                            handleUpdate({ ...record, dataRetornoRevisaoProponente: e !== null ? e.toDate() : undefined });
                        }}
                    />
            )
        });

        columns.push({
            title: 'Data Envio Área Requisitante',
            dataIndex: 'dataEnvioRevisaoAreaRequisitante',
            key: 'dataEnvioRevisaoAreaRequisitante',
            type: ColumnType.Date,
            width: '15%',
            render: (text, record, index) => (
                disabled || record.isShowActions == false
                    ? record.dataEnvioRevisaoAreaRequisitante && moment(record.dataEnvioRevisaoAreaRequisitante).format(dateFormat)
                    : <FormDatePicker
                        name='dataEnvioRevisaoAreaRequisitante'
                        value={record.dataEnvioRevisaoAreaRequisitante ? moment(record.dataEnvioRevisaoAreaRequisitante) : undefined}
                        format='DD/MM/YYYY'
                        disabled={disabled || record.isShowActions == false}
                        locale={locale}
                        allowClear
                        onChange={e => {
                            record.dataEnvioRevisaoAreaRequisitante = e !== null ? e.toDate() : undefined;
                            handleUpdate({ ...record, dataEnvioRevisaoAreaRequisitante: e !== null ? e.toDate() : undefined });
                        }}
                    />
            )
        });

        columns.push({
            title: 'Data Retorno Área Requisitante',
            dataIndex: 'dataRetornoParecerRevisaoProponente',
            key: 'dataRetornoParecerRevisaoProponente',
            type: ColumnType.Date,
            width: '15%',
            render: (text, record, index) => (
                disabled || record.isShowActions == false
                    ? record.dataRetornoParecerRevisaoProponente && moment(record.dataRetornoParecerRevisaoProponente).format(dateFormat)
                    : <FormDatePicker
                        name='dataRetornoParecerRevisaoProponente'
                        value={record.dataRetornoParecerRevisaoProponente ? moment(record.dataRetornoParecerRevisaoProponente) : undefined}
                        format='DD/MM/YYYY'
                        disabled={disabled || record.isShowActions == false}
                        locale={locale}
                        allowClear
                        onChange={e => {
                            record.dataRetornoParecerRevisaoProponente = e !== null ? e.toDate() : undefined;
                            handleUpdate({ ...record, dataRetornoParecerRevisaoProponente: e !== null ? e.toDate() : undefined });
                        }}
                    />
            )
        });

        columns.push({
            title: 'Data Realizada Área Requisitante',
            dataIndex: 'dataRealizadaRetornoParecerRevisaoProponente',
            key: 'dataRealizadaRetornoParecerRevisaoProponente',
            type: ColumnType.Date,
            width: '15%',
            render: (text, record, index) => (
                disabled || record.isShowActions == false
                    ? record.dataRealizadaRetornoParecerRevisaoProponente && moment(record.dataRealizadaRetornoParecerRevisaoProponente).format(dateFormat)
                    : <FormDatePicker
                        name='dataRealizadaRetornoParecerRevisaoProponente'
                        value={record.dataRealizadaRetornoParecerRevisaoProponente ? moment(record.dataRealizadaRetornoParecerRevisaoProponente) : undefined}
                        format='DD/MM/YYYY'
                        disabled={disabled || record.isShowActions == false}
                        locale={locale}
                        allowClear
                        onChange={e => {
                            record.dataRealizadaRetornoParecerRevisaoProponente = e !== null ? e.toDate() : undefined;
                            handleUpdate({ ...record, dataRealizadaRetornoParecerRevisaoProponente: e !== null ? e.toDate() : undefined });
                        }}
                        className={!record.dataRealizadaRetornoParecerRevisaoProponente ? 'has-error' : ''}
                    />
            )
        });

        columns.push({
            title: 'Comentários',
            dataIndex: 'comentario',
            key: 'comentario',
            width: '10%',
            align: 'center',
            render: (text, record, index) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <ModalComentariosParecerTecnico
                        contemComentario={record.contemComentario}
                        id={record.id}
                        sasPropostaId={sasProposta.id}
                        update={update}
                        disabled={true} />
                    <ModalExibicaoArquivos
                        propostaId={sasProposta.id}
                        sasTipoDocumentoId={EGuidTipoSasDocumento.PropostaTecnicaConsolidada}
                        hideExcluido={true}
                        disabled={true}
                    />
                </div>
            ),
        });

        columns.push({
            title: 'Anexo',
            dataIndex: 'anexo',
            key: 'anexo',
            width: '10%',
            render: (text, record, index) => (
                <ModalExibicaoArquivos
                    propostaId={sasProposta.id}
                    sasTipoDocumentoId={EGuidTipoSasDocumento.AceiteRecebimentoPropostaTecnicasProponentes}
                    hideExcluido={true}
                    disabled={disabled || record.isShowActions == false}
                />
            ),
        });

        columns.push({
            title: 'Ações',
            dataIndex: 'acoes',
            key: 'acoes',
            width: '10%',
            render: (text, record, index) => {
                return (
                    <Visibility visible={!disabled && record.isShowActions == true}>
                        <Tooltip title="Excluir" >
                            <Button icon='commons-trash' onClick={() => handleExcluir(record.id)} />
                        </Tooltip>
                    </Visibility>
                );
            }
        });

        return columns;
    };

    return (
        <>
            <Tooltip title='Parecer Técnico' >
                <Button icon='ecommerce-technology_items' onClick={() => {
                    setExibirModal(true);

                    var doc = vendorListDocs.find(f => f.id == sasProposta.id);
                    if (isObjNotEmpty(doc)) {
                        setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
                    }
                }} />
            </Tooltip>

            <Visibility visible={exibirModal}>

                <Modal title={`Parecer Técnico`} width="980px" visible={exibirModal} onCancel={handleCancel} footer={null} className='modal-parecer-tecnico' >
                    <Visibility visible={exibirModal && isObjNotEmpty(sasProposta)} >
                        <MasterDetailForm key={`formParecerTecnico_${sasProposta.id}_1`} initialValues={sasProposta} actions={
                            [
                                <Row style={{ paddingBottom: '16px', width: '100%' }}>
                                    {
                                        !disabled &&
                                        <Button title='Adicionar Revisão' type='primary' onClick={() => handleAdd()} style={{ float: 'left' }} />
                                    }
                                </Row>
                            ]
                        } >
                            <Row >
                                <FormSelect
                                    label='Status'
                                    name='statusResultadoParecerTecnico'
                                    value={sasProposta.statusResultadoParecerTecnico ? sasProposta.statusResultadoParecerTecnico : "Em Avaliação"}
                                    options={[
                                        { text: 'Em Avaliação', value: 'Em Avaliação' },
                                        { text: 'Aguardando Comprador', value: 'Aguardando Comprador' },
                                        { text: 'Aguardando Fornecedor', value: 'Aguardando Fornecedor' },
                                        { text: 'Em Reavaliação', value: 'Em Reavaliação' },
                                        { text: 'Aprovado', value: 'Aprovado' },
                                        { text: 'Reprovado', value: 'Reprovado' },
                                        { text: 'Concluído', value: 'Concluído' },
                                    ]}
                                    span={4}
                                    disabled />
                            </Row>

                        </MasterDetailForm>

                        <MasterDetailForm>
                            <span>Histórico de Revisões</span>
                            <Table
                                rowKey={'id'}
                                className='table-parecer-tecnico-revisoes'
                                dataSource={dadosTabela}
                                columns={columnsTable()}
                                pagination={false}
                            />
                        </MasterDetailForm>

                        <MasterDetailForm
                            initialValues={sasProposta}
                            key={`formParecerTecnico_${sasProposta.id}_2`}
                            actions={[
                                <>
                                    <Button title='fechar' type='link' onClick={() => handleCancel()} />
                                    {
                                        !disabled && <>
                                            <FormSubmitButton title='Reprovar' type='danger' noIcon onClick={(values) => {
                                                submitAprovacao({ ...values, aprovacao: false });
                                            }} />
                                            <FormSubmitButton title='Aprovar' type='primary' noIcon onClick={(values) => {
                                                submitAprovacao({ ...values, aprovacao: true });
                                            }} />
                                        </>
                                    }
                                </>
                            ]} >

                            <Row >
                                <FormTextArea
                                    label='Justificativa em caso de aprovação manual ou reprovação'
                                    name='comentarioResultadoParecerTecnico'
                                    value={formValues.comentarioResultadoParecerTecnico}
                                    onChange={e => setFormValues({ ...formValues, comentarioResultadoParecerTecnico: e.currentTarget.value })}
                                    required={!disabled && formValues.comentarioResultadoParecerTecnico === ""}
                                    disabled={disabled}
                                />
                            </Row>

                            <Row>
                                <Col span={6} >
                                    <label>Anexo Aprovação da Área Requisitante</label><br></br>

                                    {!disabled && (
                                        <UploadFile
                                            nameFormData='anexoAprovacaoAreaRequisitante'
                                            idDoComponente='anexoAprovacaoAreaRequisitante'
                                            type='primary'
                                            hasFile={false}
                                            hasLabel={false}
                                            icon='ui-upload'
                                            disabled={disabled}
                                            span={12}
                                            onChange={e => {
                                                setFormValues({ ...formValues, anexoAprovacaoAreaRequisitante: e.file });
                                            }
                                            }
                                        />
                                    )}
                                    {isObjNotEmpty(doc) && doc.anexoAprovacaoAreaRequisitante && (
                                        <Button
                                            icon='ui-download'
                                            type='primary'
                                            onClick={() => downloadArquivo(doc.anexoAprovacaoAreaRequisitante.id, doc.anexoAprovacaoAreaRequisitante.nome)}
                                        />
                                    )}
                                </Col>
                                <Col span={6}>
                                    <label>Anexo Aprovação do Gerente Geral</label><br></br>
                                    {!disabled && (
                                        <UploadFile
                                            nameFormData='anexoAprovacaoGerenteGeral'
                                            idDoComponente='anexoAprovacaoGerenteGeral'
                                            type='primary'
                                            hasFile={false}
                                            hasLabel={false}
                                            icon='ui-upload'
                                            disabled={disabled}
                                            span={12}
                                            onChange={e => setFormValues({ ...formValues, anexoAprovacaoGerenteGeral: e.file })}
                                        />
                                    )}
                                    {isObjNotEmpty(doc) && doc.anexoAprovacaoGerenteGeral && (
                                        <Button
                                            icon='ui-download'
                                            type='primary'
                                            onClick={() => downloadArquivo(doc.anexoAprovacaoGerenteGeral.id, doc.anexoAprovacaoGerenteGeral.nome)}
                                        />
                                    )}
                                </Col>
                            </Row>
                            <Visibility visible={isObjNotEmpty(step) && 'fluxoEtapaId' in step}>
                                <Row style={{ paddingTop: '32px' }} >
                                    <FormDatePicker
                                        label='Data real da conclusão do parecer técnico'
                                        name='dataRealConclusaoParecerTecnico'
                                        format="DD/MM/YYYY"
                                        span={4}
                                        onChange={e => handleEditDataResultadoParecerTecnico(e)}
                                        locale={locale}
                                        allowClear
                                        disabled={step.fluxoEtapaId !== EGuidFluxoProcessoEtapa.ParecerTecnico}
                                        value={dataRealConclusao ? moment(dataRealConclusao) : undefined}
                                    />
                                </Row>
                            </Visibility>
                        </MasterDetailForm>

                    </Visibility>
                </Modal>

            </Visibility>
        </>
    );
};

export default ModalParecerTecnico;